/**
 * @file checkbox.component.tsx
 * @path packages/ui/src/checkbox.component.tsx
 * @description
 */

import { cn } from "@sirbastians/utils";
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      // Layout & Transitions
      "peer h-5 w-5 shrink-0 rounded-md transition-all duration-200",
      "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",

      // UNCHECKED STATE: The "Soft Well" + Border
      // Added 'border border-input' so the box is visible even on white backgrounds
      "neuro-well bg-muted border",

      // CHECKED STATE: The "Hard Bezel" (Accent Color)
      // We change the border to 'border-accent' so it blends perfectly with the green fill
      "data-[state=checked]:neuro-bezel data-[state=checked]:bg-accent data-[state=checked]:text-accent-foreground data-[state=checked]:border-accent",

      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-3.5 w-3.5 stroke-[3]" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
